export function escapeHtml(text: string): string {
    const map: { [key: string]: string } = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };

    return text.replace(/[&<>"']/g, (m) => map[m]);
}

export function generateTitle(path: string): string {
    if (path === '/') return 'Home';

    return path
        .split('/')
        .filter(Boolean)
        .map(segment => {
            if (segment.startsWith('[') && segment.endsWith(']')) {
                return segment.slice(1, -1);
            }
            return segment.charAt(0).toUpperCase() + segment.slice(1);
        })
        .join(' ');
}

export function isValidPageFile(filePath: string): boolean {
    const ext = filePath.split('.').pop()?.toLowerCase();
    return ['tsx', 'jsx', 'ts', 'js'].includes(ext || '');
}

export function isDynamicRoute(path: string): boolean {
    return path.includes('[') && path.includes(']');
}

export function extractParams(path: string): string[] {
    const matches = path.match(/\[([^\]]+)\]/g);
    return matches ? matches.map(match => match.slice(1, -1)) : [];
}

export function defineConfig(config: any) {
    return config;
}
